import Clipboard from "./admin/clipboard.js";
import { initColours } from "./admin/colours.js";
import linkedPosts from "./linked-posts.js";

Clipboard();

linkedPosts();
initColours();
